import React, { memo } from "react";

export type TooltipProps = {
  children: React.ReactNode;
  text: string;
  position?: "top" | "right";
};

const positionClasses = {
  top: "-top-10 left-1/2 -translate-x-1/2 before:left-1/2 before:top-full before:-translate-x-1/2 before:border-t-black",
  right:
    "left-full top-1/2 ml-2 -translate-y-1/2 before:right-full before:top-1/2 before:-translate-y-1/2 before:border-r-black",
};

const Tooltip: React.FC<TooltipProps> = memo(
  ({ children, text, position = "top" }) => {
    return (
      <span className="group relative">
        <span
          className={`pointer-events-none absolute z-50 whitespace-nowrap rounded bg-black px-2 py-1 text-sm text-white opacity-0 transition before:absolute before:border-4 before:border-transparent before:content-[''] group-hover:opacity-100 ${positionClasses[position]}`}
        >
          {text}
        </span>

        {children}
      </span>
    );
  },
);

Tooltip.displayName = "Tooltip";

export default Tooltip;
